import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/lookup`;

const lookupService = {
    getProductGroupLookup: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/product-group`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    getProductsLookup: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/products`, {
            params
        }).then((response) => {
            return response.data;
        });
    }
}
export default lookupService